/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Whtr_Band_Note_IncreasedInputs */

const en_us2_body_assessment_whtr_band_note_increased = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_IncreasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your waist is between 50% and 60% of your height. NICE ties that range to increased cardiometabolic risk.`)
};

const pt_br2_body_assessment_whtr_band_note_increased = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_IncreasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sua cintura está entre 50% e 60% da altura. O NICE associa essa faixa a risco cardiometabólico aumentado.`)
};

const es_419_body_assessment_whtr_band_note_increased = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_IncreasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu cintura está entre el 50% y el 60% de tu estatura. El NICE asocia ese rango con un riesgo cardiometabólico aumentado.`)
};

const pt_pt2_body_assessment_whtr_band_note_increased = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_IncreasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua cintura está entre 50% e 60% da altura. O NICE associa este intervalo a um risco cardiometabólico aumentado.`)
};

const fr_fr2_body_assessment_whtr_band_note_increased = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_IncreasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton tour de taille est entre 50 % et 60 % de ta hauteur. Le NICE associe cette zone à un risque cardiométabolique accru.`)
};

const de_de2_body_assessment_whtr_band_note_increased = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_IncreasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Taille liegt zwischen 50 % und 60 % deiner Größe. NICE verbindet diesen Bereich mit erhöhtem kardiometabolischem Risiko.`)
};

const it_it2_body_assessment_whtr_band_note_increased = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_IncreasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua vita è tra il 50% e il 60% dell'altezza. Il NICE associa questo intervallo a un rischio cardiometabolico aumentato.`)
};

/**
* | output |
* | --- |
* | "Your waist is between 50% and 60% of your height. NICE ties that range to increased cardiometabolic risk." |
*
* @param {Body_Assessment_Whtr_Band_Note_IncreasedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_whtr_band_note_increased = /** @type {((inputs?: Body_Assessment_Whtr_Band_Note_IncreasedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Whtr_Band_Note_IncreasedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_whtr_band_note_increased(inputs)
	if (locale === "es-419") return es_419_body_assessment_whtr_band_note_increased(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_whtr_band_note_increased(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_whtr_band_note_increased(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_whtr_band_note_increased(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_whtr_band_note_increased(inputs)
	return en_us2_body_assessment_whtr_band_note_increased(inputs)
});
export { body_assessment_whtr_band_note_increased as "body-assessment.whtr_band_note.increased" }